import { AffectedStaffMap } from '../../lib/types/models/affectedStaff/affected-staff'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedStaff<T extends keyof AffectedStaffMap>(
  id: number,
  version: T = 'FULL' as T
) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.affectedStaffs.get.url, { id }), { version }))
    .get<AffectedStaffMap[T]>()
}
